import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import GetPageData from "../hooks/GetPageData";
import NavAndFooter from "../GramPages/Common/NavAndFooterContainer/index";
import LoadingComponet from "../components/Loading/LoadingComponet";

import HomePage from "../GramPages/Home";
import AboutUs from "../Pages/AboutUs";
import PanchayatPeople from "../GramPages/PanchayatPeople";
import GalleryPage from "../GramPages/Gallery";
import InfoPage from "../GramPages/InfoPage";
import ModalContainer from "../ModalLayouts/ModalContainer";
import { RootUrl } from "../redux/types";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentGram } from "../redux/action/utilActions";
import NotFound from "./NotFound";
import GramRoutes from "./GramRoutes";
import { Helmet } from "react-helmet";

// import GramSchemes from "../Pages/GramSchemes";
// import FormsPage from "../Pages/Forms/index";
// import GalleryPage from "../Pages/Gallery/index";
// import ContactUs from "../Pages/Contactus";
// import Suggetions from "../Pages/Suggetions";
// import GramHome from "../Pages/GramHome";
// import ModalContainer from "../ModalLayouts/ModalContainer";
// import TermsPage from "../Pages/TermsAndConditions";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
}));

const CheckIfGramNot = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [gramNotFound, setGramNotFound] = React.useState(false);

  const gramId = useSelector((state) => state.util.currentGramId);
  console.log("available gram", props.gram);
  const getGramId = async () => {
    setLoading(true);
    await Axios.get(`${RootUrl}/getGramId/${props.gram}`, {
      headers: {
        // "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
      },
    })
      .then((res) => {
        console.log("axios", res.data);
        if (res.data.data === null) {
          setGramNotFound(true);
          setLoading(false);
        } else {
          setGramNotFound(false);
          dispatch(setCurrentGram(res.data.data));
          setLoading(false);
        }
      })
      .catch((err) => {
        setGramNotFound(true);

        setLoading(false);
      });
    setLoading(false);
  };

  React.useEffect(() => {
    getGramId();
  }, []);

  return (
    <>
      <Helmet>
        <title>Egram Panchayat</title>
        <meta name="description" content="Welcome to e-gram panchayat" />

        <meta property="og:title" content={`${props.gram} Egram panchayat`} />
        <meta
          property="og:url"
          content={`https://${props.gram}.egrampanchayat.in`}
        />
        <meta
          property="og:description"
          content={`${props.gram} gram panchayat website`}
        />
        <meta
          property="og:image"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
      </Helmet>
      {loading ? (
        <LoadingComponet />
      ) : (
        <>{gramNotFound ? <NotFound /> : <GramRoutes gram={props.gram} />}</>
      )}
    </>
  );
  // const { ready, data, error } = GetPageData(`getGramId/parpada`);

  // const ScrollToTop = () => {
  //   window.scrollTo(0, 0);
  //   return null;
  // };
  // return ready && data ? (
  //   <GramRoutes gram={props.gram} />
  // ) : (
  //   <div>
  //     <LoadingComponet />
  //   </div>
  // );
};
export default CheckIfGramNot;
